"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLinkPaste = void 0;
const slate_1 = require("slate");
const link_1 = require("./link");
const URL_REGEX = /^https?:\/\/\S+$/i;
const isInRawTextBlock = (editor) => {
    const { selection } = editor;
    if (!selection)
        return false;
    const [match] = slate_1.Editor.nodes(editor, {
        at: slate_1.Editor.unhangRange(editor, selection),
        match: (node) => node?.type === 'code-block' || node?.type === 'pre',
    });
    return !!match;
};
/**
 * When a URL is pasted while a non-empty range is selected, attach the URL
 * as a link to the selected text instead of replacing it.
 */
const withLinkPaste = (editor) => {
    const reactEditor = editor;
    const { insertData } = reactEditor;
    if (!insertData)
        return editor;
    reactEditor.insertData = (data) => {
        const { selection } = editor;
        if (selection && !slate_1.Range.isCollapsed(selection) && !isInRawTextBlock(editor)) {
            const text = data.getData('text/plain').trim();
            if (text && URL_REGEX.test(text)) {
                (0, link_1.upsertLink)(editor, text);
                return;
            }
        }
        insertData(data);
    };
    return editor;
};
exports.withLinkPaste = withLinkPaste;
